<template>
    <div v-if = "incident">
        <v-menu
            nudge-left ="-10"
            nudge-top  ="10"
            v-model    ="changeOpen"
            :close-on-content-click="false"
            close-on-click
            offset-x
        >
            <template v-slot:activator="{ on: menu, attrs }">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on: tooltip }">
                        <v-btn
                            small
                            fab
                            v-bind="attrs"
                            v-on="{ ...tooltip, ...menu }"
                        >
                            <v-icon color="primary">mdi-swap-horizontal</v-icon>
                        </v-btn>
                    </template>
                    <span>{{ $t("inc.edit.menu.change") }}</span>
                </v-tooltip>
            </template>

            <c-column-header :label="$t('inc.change.title')" class="primary" title-border>
                <template v-slot:pre>
                    <div style="min-width: 18px"></div>
                </template>
            </c-column-header>

            <v-list >
                <template v-for="(item, index) in allowed">
                    <v-list-item
                        link
                        :key="index"
                        @click="onChange(item)"
                    >
                        <v-list-item-title>
                            {{ item.name }}
                        </v-list-item-title>
                    </v-list-item>
                </template>
            </v-list>
        </v-menu>
    </div>
</template>

<script>

import Inc           from "@/modules/inc/service/Inc";
import CColumnHeader from "@/modules/core/components/utils/CColumnHeader.vue";
import Core          from "@/modules/core/service/Core";

export default {
    name: "IncChangeButton",
    components: {
        CColumnHeader,
    },
    props: {
        incident: {
            required: false,
            default: function () {
                return null;
            }
        },

        allowed: {

        }
    },

    data: () => ({
        changeOpen : false,
        showConfirm: false,
        selected   : null,
    }),

    watch: {
        changeOpen () {
            this.$emit("opend", this.changeOpen)
        },
    },

    computed: {
    },

    methods: {
        onChange (item) {
            let title = this.$t("inc.change.title");
            let text = this.$t("inc.change.confirm", [ this.incident.typeName, item.name ]);

            if (item.id === 23) {
                text = text + "<br><br><p class=error--text>Alle ggf. bereits vorhandenen Komponenten werden hierbei gelöscht!</p>";
            }

            Core.message.confirm(
                this,
                title,
                text,
                Core.message.Default,
                (value) => {
                    if (!value) {
                        return;
                    }

                    Inc.changeType(this.incident.id, item.id, () => {
                        this.$emit("changed", this.incident);
                    });
                });
        },
    }
}
</script>

<!--suppress CssUnusedSymbol -->
<style scoped>

.confirm-panel {
    position: absolute;
    z-index: 10;
    left: 330px;
    margin-top: 50px;
}

::v-deep .theme--light.v-btn.v-btn--disabled {
    border-color: lightgrey;
    border-width: 1px;
    border-style: solid;
    box-shadow: none;
}

</style>